import { render, staticRenderFns } from "./StudentInfoPage.vue?vue&type=template&id=62c642ba&"
import script from "./StudentInfoPage.vue?vue&type=script&lang=js&"
export * from "./StudentInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports